/**
 * I believe John wrote this one as part of the AMP-3 work. Putting this out here for visibility.
 * Though, I'm not sure if we're gonna continue to use Peity.
 *
 * The raw data is being displayed for about a second before the graph is rendered.
 * Not sure if that's a feature or a bug.
 */
interface JQuery {
  peity: any;
}

class MiniGraphController {
  static bindings = {
    type: '@',
    data: '@',
    percentage: '<'
  };

  type;
  data; // this is a reserved name, we can't use this
  percentage;

  constructor(private $timeout) {
    'ngInject';
  }

  $onInit() {
    this.type = this.type || 'pie';

    if (this.percentage) {
      this.data = `${this.percentage}/100`;
    }

    this.$timeout(() => {
      ($(`span.${this.type}`) as any).peity(this.type);
    }, 0);
  }

  $onChanges(changesObj) {
    if (changesObj.percentage) {
      this.data = `${changesObj.percentage.currentValue}/100`;
    }

    this.$timeout(() => {
      $(`span.${this.type}`).change();
    }, 0);
  }
}

export const MiniGraphComponent = {
  bindings: MiniGraphController.bindings,
  // FIXME: Use a Typescript class for the controller
  controller: MiniGraphController,
  template: `<span data-peity='{ "fill": ["#fdbb30", "#f2f2f2"], "radius": 13 }' class="{{ $ctrl.type }}"
                   ng-bind-html="$ctrl.data"></span>`
};
